<template>
  <div class="passingStyle_pie" :class="isAutoExportPng ? 'autoExportPng' : ''">
    <div class="vertical_box">
      <span class="vertical_box_title" v-text="'传球方向'"></span>
      <div :class="isBorder ? 'echartsBorder' : ''" class="echartsBg">
        <div
          id="chartDom"
          ref="chartDom"
          :style="{ height: chartDomHPx }"
          @click.stop="downLoad($refs.chartDom, true)"
        ></div>
      </div>
    </div>
    <div class="tip_box" v-if="isTipFlag">
      <div class="imageArea">
        <span class="player_image" :class="playerLogo ? 'isLogo' : ''">
          <img v-if="playerLogo" :src="playerLogo" />
        </span>
        <span class="imageText_area">
          <span class="playerName" v-text="playerName"></span>
          <span class="teamInfor">
            <span class="teamImage">
              <img :src="teamLogo" />
            </span>
            <span class="teamName" v-text="teamName"></span>
          </span>
        </span>
      </div>

      <!-- <span class="playeName" v-text="`${item.val}`"></span> -->
      <span class="player_datas">
        <span class="itemData" v-for="(item, index) in tipList" :key="index">
          <template>
            <span class="title" v-text="`${item.name} `"></span>
            <span class="val" v-text="item.val"></span>
          </template>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
// 球员传球风格
import cup_base_data_mixin from '@mixins/cup_base_data'
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'coordinateSystemScatter',
  mixins: [canvasToImage_base64_data_mixin, cup_base_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isBorder: {
      //演播室要球场和边界区域一起的，所以不要边，比例是2000/1340=1.49，约等于1.5
      type: Boolean,
      default: false,
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
    isTipFlag: {
      //是否展示提示信息
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      homeBgColor: 'rgba(235, 27, 80, 1)', //扇形色块的颜色
      initFlag: false,
      myChart: null,
      homeData: [],
      awayData: [],
      chartDomHPx: 'auto',
      playerLogo: '',
      playerName: '',
      teamName: '',
      teamLogo: '',
      pieData: [],
      tipList: [
        {
          name: '传球次数',
          key: 'passTimes',
          val: '',
          ceil: '次',
        },
        {
          name: '平均传球距离',
          key: 'passDis',
          val: '',
          ceil: '米',
        },
        {
          name: '传球成功率',
          key: 'passTimes',
          val: '',
          ceil: '%',
        },
        {
          name: '对方半场',
          key: 'passTimes',
          val: '',
          ceil: '%',
        },
        {
          name: '已方半场',
          key: 'passTimes',
          val: '',
          ceil: '%',
        },
      ],
    }
  },
  created() {
    if (this.currThemeObj && this.currThemeObj.cssStyle) {
      const cssStyle = this.currThemeObj.cssStyle
      // console.debug("cssStyle:", cssStyle)
      this.homeBgColor = cssStyle.echarts_keyEventBar_homeColor
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initEchartFlag()
    })
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myChart) {
      this.myChart.dispose() //销毁echarts实例，防止内侧泄露
    }
  },
  components: {},
  watch: {
    datas(val) {
      if (this.initFlag && this.myChart) {
        this.initdata(val)
        this.initEcharts()
      }
    },
  },
  methods: {
    initEchartFlag() {
      setTimeout(() => {
        if (this.$refs.chartDom && this.$refs.chartDom.clientWidth) {
          this.chartDomHPx = `${Math.ceil(
            this.$refs.chartDom.clientWidth * 1.5
          )}px`
          this.symbolSize = Math.floor(this.$refs.chartDom.clientWidth * 0.056)
          console.debug('this.symbolSize:', this.symbolSize)
          this.$nextTick(() => {
            this.initdata(this.datas)
            // this.initdata(dataList) //测试数据入口
            this.initFlag = true
            this.initEcharts()
            // this.myChart.on('click', 'series.line', (params) => {
            //   console.debug(params)
            //   if (params.componentType == 'markPoint') {
            //     // 点击了 markPoint
            //     this.isMarkFlag = true
            //   }
            // })
          })
        } else {
          this.initEchartFlag()
        }
      }, 50)
    },
    initdata(datas) {
      // dataList = [[{ averageX: 59, averageY: 51, shirtNumber: 9 }]]
      console.debug('datas:', datas)
      let pieData = []
      const tipListKey = [
        'passes',
        'averagePassingDistance',
        'passingAccuracy',
        'oppHalfPassingAccuracy',
        'ownHalfPassingAccuracy',
      ]
      const tipList = this.tipList
      const echartData =
        datas && datas.data && datas.data.dataList && datas.data.dataList[0]
          ? datas.data.dataList[0]
          : {}
      pieData = echartData.passingAngleDistribution
        ? echartData.passingAngleDistribution
        : []
      tipList.forEach((item, index) => {
        item.val = this._valFormatHandler(
          echartData[tipListKey[index]],
          item.ceil
        )
      })
      this.tipList = tipList
      this.pieData = pieData

      const objectInfo =
        datas && datas.objectInfo && datas.objectInfo[0].playerInfos[0]
          ? datas.objectInfo[0].playerInfos[0]
          : {}
      this.playerLogo = objectInfo.profilePicture
        ? objectInfo.profilePicture
        : ''
      this.playerName = objectInfo.playerName ? objectInfo.playerName : ''
      this.teamName = datas.objectInfo[0].teamName
        ? datas.objectInfo[0].teamName
        : ''
      this.teamLogo = datas.objectInfo[0].teamLogo
        ? datas.objectInfo[0].teamLogo
        : ''
    },
    _valFormatHandler(val, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ' -'
      } else {
        if (val && ceil) {
          data = `${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
    clickEchartBox(e) {
      console.debug(e)
      if (!this.isMarkFlag) {
        // 清空关键事件
        console.debug('清空关键事件')
      }
      this.isMarkFlag = false
    },
    initEcharts() {
      // 2000/1340
      const dom = this.$refs.chartDom
      const pieData = this.pieData
      const width = dom.clientWidth
      const size = pieData.length === 8 ? Math.floor(width * 0.4) : 0
      let option = {
        title: {
          show: false,
          text: '传球风格',
        },
        animation: !this.isAutoExportPng,
        grid: {
          top: `0`,
          bottm: `0`,
          left: '1.4%',
          right: '1.4%',
          width: '97.2%',
          height: `100%`,
        },
        color: [this.homeBgColor],
        // dataZoom: {
        //   show: true,
        //   type: 'inside',
        //   zoomLock: true,
        // },
        legend: {
          show: false,
        },
        series: [
          {
            type: 'pie',
            radius: [1, size],
            center: ['50%', '50%'],
            roseType: 'area',
            startAngle: 90,
            clockwise: false,
            itemStyle: {
              borderColor: 'rgba(54, 6, 25, 1)',
              borderWidth: 1,
              borderRadius: 0,
            },
            labelLine: {
              show: false,
            },
            label: {
              show: false,
            },
            // data: [
            //   { value: 40, name: 'pass 1' },
            //   { value: 28, name: 'pass 2' },
            //   { value: 26, name: 'pass 3' },
            //   { value: 4, name: 'pass 4' },
            //   { value: 32, name: 'pass 5' },
            //   { value: 10, name: 'pass 6' },
            //   { value: 18, name: 'pass 7' },
            //   { value: 16, name: 'pass 8' },
            // ],
            data: pieData,
          },
        ],
      }
      this.myChart = this.$echarts.init(this.$refs.chartDom)
      this.myChart.setOption(option)

      if (this.isAutoExportPng) {
        setTimeout(() => {
          this.upLoad(
            this.$refs.chartDom,
            true,
            'uploadData',
            this.datas.data.legendData
          )
        }, 5 * 1000)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.passingStyle_pie {
  position: relative;
  width: 86%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  &.autoExportPng {
    width: 100%;
    .vertical_box {
      border: 0;
      background: transparent;
      border-radius: 0;
    }
  }
  .vertical_box {
    position: relative;
    width: 35%;
    border: 0.416vw solid var(--mixtmt_echarts_footBallPlaygroundColor);
    background: var(--mixtmt_echarts_footBallPlaygroundColor);
    border-radius: 0.694vw;
    .vertical_box_title {
      position: absolute;
      top: -2.22vw;
      left: 0;
      z-index: 2;
      width: 100%;
      font-size: 0.972vw;
      line-height: 1.944vw;
      text-align: center;
      font-weight: bold;
      color: var(--mixtmt_greyColor_main);
    }
  }
  .echartsBg {
    background-color: var(--mixtmt_echarts_footBallPlaygroundBgColor);
  }
  .tip_box {
    width: 60%;
    height: auto;
    padding: 0 0.694vw;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .imageArea {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      .player_image {
        width: 6.25vw;
        height: 6.25vw;
        overflow: hidden;
        background-image: var(--mixtmt_default_playerLogo);
        background-size: 100% auto;
        background-position: center top;
        background-repeat: no-repeat;
        /* object-fit: contain; */
        &.isLogo {
          background-image: none;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .imageText_area {
        width: calc(100% - 6.25vw);
        padding: 0 0.694vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 0.972vw;
        line-height: 2.083vw;
        font-weight: bold;
        color: var(--mixtmt_greyColor_main);
        .teamInfor {
          width: 100%;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          .teamImage {
            width: 1.666vw;
            height: 1.666vw;
            overflow: hidden;
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .teamName {
            padding-left: 2.083vw;
          }
        }
      }
    }

    .player_datas {
      padding-top: 1.042vw;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;
      .itemData {
        padding: 0 0.694vw;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        font-size: 0.972vw;
        line-height: 2.083vw;
        color: var(--mixtmt_greyColor_main);
        &:nth-child(2n) {
          background-color: var(--mixtmt_subColor_main);
        }
        .title {
          font-weight: bold;
        }
      }
    }
  }
}
.echartsBorder {
  border: 0.416vw solid #eaedf1;
  background: #eaedf1;
  border-radius: 0.694vw;
}
#chartDom {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  background-image: var(--mixtmt_ball_ver_bg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  font-size: 0;
}
</style>
